import { ParkingContainer } from '../../containers/advancedFilters/ParkingContainer';
import { type IFilter } from '../../types/advancedFilters';

export const parking: IFilter = {
  component: ParkingContainer,
};
